import { action, makeObservable, observable } from 'mobx';
import { createContext, useContext } from 'react';
import { localStorageDef } from '../commons/consts';
import { getLinkTo } from '../commons/route';
import Storage from '../commons/storage';
import { changeLanguage } from '../commons/i18';

type AccessUserInfo = { iat: number; uuid: string; sub: string; nome: string; aplicacaoLogged: string };

export class Ctx {
  constructor() {
    //Modifica classe pra ser observável
    makeObservable(this);

    this.obterUsuario();
    this.obterI18N();
  }

  @observable usuario = {} as AccessUserInfo;
  @observable aplicacao = {} as { uuid: string; nome?: string };

  alterarLanguage(lng?: string): Promise<Function> {
    Storage.setItem(localStorageDef.i18nContextKey, lng);
    return changeLanguage(lng);
  }

  @action obterI18N() {
    const lng = Storage.getItem(localStorageDef.i18nContextKey, null)
    if (lng) {
      changeLanguage(lng);
    }
  }

  //Realiza autenticação do usuário
  @action
  login(usuario: any, token: string | null, expiraEm: number | null): void {
    this.salvarUsuario(usuario, token, expiraEm);
  }

  @action
  logout() {
    this.salvarUsuario({}, null, null);
    window.location.href = getLinkTo('logout');
  }

  @action obterUsuario() {
    this.usuario = Storage.getItem(localStorageDef.usuarioContextKey, {});
  }

  @action salvarUsuario(usuario: any, token: string | null, expiraEm: number | null) {
    Storage.setItem(localStorageDef.usuarioContextKey, usuario);

    this.usuario = usuario;
  }
}

const UserCtxInstance = new Ctx();
export default UserCtxInstance;

export const UserContext = createContext<Ctx>({} as Ctx);
export const UserProvider = UserContext.Provider;
export const useUserStore = (): Ctx => useContext(UserContext);
